// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { ReplaySubject } from 'rxjs';

// --- HS Code
import { EventTypes, OidcClientNotification } from '../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class EventService {
  private notify = new ReplaySubject<OidcClientNotification<any>>(1);

  fireEvent<T>(type: EventTypes, value?: T) {
    this.notify.next({ type, value });
  }

  registerForEvents() {
    return this.notify.asObservable();
  }
}
